import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { en } from './en.js'
import type { accountEn } from './account.js'
import type { adminEn } from './admin.js'
import type { curateEn } from './curate.js'
import type { impersonationEn } from './impersonation.js'
import type { journeyEn } from './journey.js'
import type { lessonEn } from './lesson.js'
import type { passkeysEn } from './passkeys.js'
import type { watchEn } from './watch.js'

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation'
    // Sign-in, account, passkey, admin, banner, journey and curation messages arrive with their
    // lazy chunks (i18n/account.ts, passkeys.ts, admin.ts, impersonation.ts, journey.ts,
    // curate.ts, watch.ts, lesson.ts), but are typed here.
    resources: {
      translation: typeof en &
        typeof accountEn & {
          passkeys: typeof passkeysEn
          admin: typeof adminEn
          curate: typeof curateEn
          impersonation: typeof impersonationEn
          journey: typeof journeyEn
          watch: typeof watchEn
          lesson: typeof lessonEn
        }
    }
  }
}

// English only for now; German is added as a second resource later (product spec §9).
void i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  resources: { en: { translation: en } },
  interpolation: { escapeValue: false },
  initAsync: false,
})

export { i18next }
